module.exports = __webpack_public_path__ + "static/media/give.2d77c2fd.svg";